export default "__VITE_ASSET__90fd0326__"